/**
 * TK-48 §0.6 — nút "Cài ứng dụng" (PWA), theo hành vi thật của `InstallApp.tsx` bản ChatGPT v06:
 *   · bắt `beforeinstallprompt` TRƯỚC khi React gắn (trình duyệt có thể phát ngay lúc tải);
 *   · trình duyệt cho cài ⇒ bấm mở hộp cài của trình duyệt; chưa cho ⇒ hộp hướng dẫn (qua `Modal` chung);
 *   · đã cài (`display-mode: standalone` hoặc `appinstalled`) ⇒ KHÔNG hiện.
 *   Màn rộng: thanh trên. Màn hẹp: trong menu tài khoản (`dang="menu"`).
 */
import { useState, useSyncExternalStore } from 'react';
import { Download } from 'lucide-react';
import { Modal } from './ui';

type SuKienCai = Event & { prompt: () => Promise<void>; userChoice: Promise<{ outcome: 'accepted' | 'dismissed' }> };
let suKien: SuKienCai | null = null;
const dungRieng = typeof window !== 'undefined' && window.matchMedia ? window.matchMedia('(display-mode: standalone)') : null;
let daCai = !!dungRieng?.matches || Boolean((typeof navigator !== 'undefined' ? navigator as Navigator & { standalone?: boolean } : null)?.standalone);
let lan = 0;
const nghe = new Set<() => void>();
const bao = () => { lan++; nghe.forEach((f) => f()); };
if (typeof window !== 'undefined') {
  window.addEventListener('beforeinstallprompt', (e) => { e.preventDefault(); suKien = e as SuKienCai; bao(); });
  window.addEventListener('appinstalled', () => { daCai = true; suKien = null; bao(); });
  dungRieng?.addEventListener('change', () => { daCai = dungRieng.matches; bao(); });
}

export function CaiUngDung({ dang = 'thanh' }: { dang?: 'thanh' | 'menu' }) {
  useSyncExternalStore((f) => { nghe.add(f); return () => { nghe.delete(f); }; }, () => lan);
  const [huongDan, setHuongDan] = useState(false);
  const [dangMo, setDangMo] = useState(false);
  if (daCai) return null;
  const cai = async () => {
    if (!suKien) { setHuongDan(true); return; }
    const e = suKien; suKien = null; bao(); setDangMo(true);
    try { await e.prompt(); if ((await e.userChoice).outcome === 'dismissed') setHuongDan(true); }
    catch { setHuongDan(true); }
    finally { setDangMo(false); }
  };
  const chu = dangMo ? 'Đang mở…' : 'Cài ứng dụng';
  return (
    <>
      {dang === 'menu'
        ? <button type="button" onClick={() => void cai()} disabled={dangMo} data-o="cai-ung-dung"
            className="flex w-full items-center gap-2 px-3 py-2 text-left text-sm text-chu-1 hover:bg-nen-2"><Download className="h-4 w-4 text-chu-3" />{chu}</button>
        : <button type="button" onClick={() => void cai()} disabled={dangMo} data-o="cai-ung-dung" className="nut-cai-ung-dung" title="Cài ứng dụng SDKD">
            <Download className="h-4 w-4" aria-hidden="true" /><span>{chu}</span></button>}
      <Modal open={huongDan} onClose={() => setHuongDan(false)} title="Cài ứng dụng SDKD">
        {typeof window !== 'undefined' && !window.isSecureContext
          ? <p className="m-0 text-sm text-chu-1">Địa chỉ HTTP này chưa đủ điều kiện để trình duyệt cài ứng dụng. Mở trang qua địa chỉ HTTPS của hệ thống rồi thử lại.</p>
          : <div className="flex flex-col gap-2 text-sm text-chu-1">
              <p className="m-0">Chrome / Edge: menu trình duyệt › Cài ứng dụng (hoặc Thêm vào màn hình chính). iPad / iPhone: Safari › Chia sẻ › Thêm vào màn hình chính.</p>
              <p className="m-0 text-chu-2">Trình duyệt quyết định khi nào cho cài; chưa thấy tuỳ chọn thì chờ trang tải xong rồi tải lại.</p>
            </div>}
      </Modal>
    </>
  );
}
